// extracted by mini-css-extract-plugin
export var formContainer = "_g4-0";
export var message = "_g4-1";